export { Api } from '@/tacrmApi'

export const baseUrl = import.meta.env.VITE_API_DOMAIN_URL

// OpenAPI types
export type FlightSegment = import('@/tacrmApi').InternalAppFlightsDetailedFlightResponse
export type Traveler = import('@/tacrmApi').InternalAppTravelersTravelerPreferenceResponse
export type Credit = import('@/tacrmApi').InternalAppCreditsBaseCreditResponse
export type Invoice = import('@/tacrmApi').InternalAppInvoicesDetailedInvoiceResponse
export type YearMetrics = import('@/tacrmApi').InternalAppInvoicesYearMetrics
export type RangeMetrics = import('@/tacrmApi').InternalAppInvoicesRangeMetrics
export type UpdatePreferencesResponse =
  import('@/tacrmApi').InternalAppTravelersUpdatePreferencesResponse

// Manual Types
export interface GetPresignedUrlResponse {
  url: string
}
export interface UpdatePreferencesRequest {
  seat: string
  meal: string
  cabin_class: string
  preferred_airline_id: number | null
}

// Enums
export enum FlightStatus {
  //Forfeited = 'Forfeited',
  //Throwaway = 'Throwaway',
  Used = 'Used',
  Open = 'Open',
  Exchanged = 'Exchanged',
  Void = 'Void',
  Refunded = 'Refunded',
}

export enum TicketStatus {
  Active = 'A',
  Exchange = 'E',
  Refund = 'R',
  Used = 'U',
  Open = 'O',
  Void = 'V',
}

export enum InvoiceType {
  Active = 'ACTIVE',
  Exchange = 'EXCHANGE',
  Refund = 'REFUND',
}

export enum InvoiceStatus {
  Submitted = 'SUBMITTED',
  InvoiceTodo = 'INVOICE',
  BillTodo = 'BILL',
  RefundTodo = 'REFUND',
  Void = 'VOID',
  Invoiced = 'INVOICED',
  Billed = 'BILLED',
  Refunded = 'REFUNDED',
  Reviewed = 'REVIEWED',
  Closed = 'CLOSED',
}

export const CompletedInvoiceStatus = [
  InvoiceStatus.Reviewed,
  InvoiceStatus.Billed,
  InvoiceStatus.Refunded,
]

export const PendingInvoiceStatus = [InvoiceStatus.BillTodo, InvoiceStatus.RefundTodo]

export enum PreferredSeat {
  AISLE = 'AISLE',
  WINDOW = 'WINDOW',
  MIDDLE = 'MIDDLE',
  EXIT_ROW = 'EXIT_ROW',
  NO_PREFERENCE = 'NO_PREFERENCE',
}

export enum PreferredMeal {
  VEGAN = 'VEGAN',
  VEGETARIAN = 'VEGETARIAN',
  KOSHER = 'KOSHER',
  HALAL = 'HALAL',
  DIABETIC = 'DIABETIC',
  NO_PREFERENCE = 'NO_PREFERENCE',
}

export enum PreferredCabinClass {
  FIRST = 'FIRST',
  BUSINESS = 'BUSINESS',
  ECONOMY = 'ECONOMY',
  PREMIUM_ECONOMY = 'PREMIUM_ECONOMY',
  NO_PREFERENCE = 'NO_PREFERENCE',
}

export interface AppHealthStatus {
  ok: boolean
  appClient: boolean
  appAuth: boolean
  user: {
    id: string | null
    ok: boolean
  }
  company: {
    id: string | null
    ok: boolean
  }
}
